import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { getCostText } from '../utils/getCostInfo';
import FormattersStore from '../stores/Formatters';

const styles = {
  strikeThroughPriceContainer: {
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap'
  },
  costText: {
    textDecoration: 'line-through',
    color: 'section',
    marginRight: 'xsmall'
  },
  salePercentage: {
    fontSize: 'small',
    color: 'section',
    paddingVertical: '0',
    paddingHorizontal: 'xxsmall',
    backgroundColor: '#A6FFF8',
    borderRadius: '4px'
  },
  salePrice: {
    marginRight: 'xsmall',
    color: 'section'
  },
  normalCostText: {
    color: 'section'
  }
};

const StrikeThroughPrice = ({ service, staticContent, isSalePercentageDisplayed }) => {
  const { numberFormatter } = FormattersStore.getState();
  const { Element } = UX2.Element;

  const salePrice = service.sales_price;

  const costText = getCostText(service, staticContent);
  const isTaxIncluded = Boolean(service.tax_category && service.tax_category.tax_included_in_price);
  const salePriceText = numberFormatter.formatCurrency(Number(salePrice), { withDecimal: false });
  const cost = isTaxIncluded ? service.cost_with_tax : service.cost;
  const salePercentage = Math.round(((Number(cost) - Number(salePrice)) / Number(cost)) * 100);

  if (!salePrice || salePrice === cost) {
    return <Element style={ styles.normalCostText }>{ costText }</Element>;
  }

  return (
    <Element style={ styles.strikeThroughPriceContainer }>
      <Element style={ styles.salePrice }>{ salePriceText }</Element>
      <Element style={ styles.costText }>{ costText }</Element>
      { isSalePercentageDisplayed && (
        <Element style={ styles.salePercentage }>{ `SAVE ${salePercentage}%` }</Element>
      ) }
    </Element>
  );
};

StrikeThroughPrice.propTypes = {
  costText: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  salesPrice: PropTypes.string,
  staticContent: PropTypes.object,
  salePriceText: PropTypes.string,
  isSalePercentageDisplayed: PropTypes.bool
};

StrikeThroughPrice.defaultProps = {
  isSalePercentageDisplayed: true
};

export default StrikeThroughPrice;
